import styled from "styled-components";

export const Container = styled.div`
  min-width: ${(props) => {
    if (props.$menuMinimized) return "3.5em";
    if (props.$editMode) return "20em"; // Mais largo no modo de edição
    return "15em";
  }};
  width: ${(props) => {
    if (props.$menuMinimized) return "3.5em";
    if (props.$editMode) return "20em"; // Mais largo no modo de edição
    return "15em";
  }};
  height: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(13, 15, 20, 0.92);
  border-right: 1px solid rgba(255, 255, 255, 0.04);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: #e5e7eb;
  user-select: none;
`;

export const Header = styled.div`
  width: 100%;
  height: 4em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(18, 20, 26, 0.88);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding-left: 10px;

  .logo-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.9;

    &:hover {
      opacity: 1;
      transform: scale(1.05);
    }
  }

  .logo-full {
    width: 110px;
    height: auto;
    object-fit: contain;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.95;
    transform: translateX(-1em);

    &:hover {
      opacity: 1;
    }
  }
`;

export const Buttons = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: overlay;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  /* Estilo da scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    transition: background 0.2s;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  .menu-section {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      padding: 0.8em 0 0.5em 1em;
      font-size: 0.7em;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #e5e7eb;
      opacity: 0.4;
      border-top: 1px solid rgba(255, 255, 255, 0.04);
      margin-top: 0.5em;

      &:first-child {
        border-top: none;
        margin-top: 0;
      }
    }
  }
`;

export const Button = styled.div`
  width: 100%;
  min-height: 3em;
  display: flex;
  background-color: ${(props) =>
    props.$active ? "rgba(16, 185, 129, 0.06)" : "transparent"};
  align-items: center;
  justify-content: ${(props) =>
    props.$menuMinimized ? "center" : "flex-start"};
  padding: 0;
  margin: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  opacity: ${(props) => props.$isHidden ? "0.4" : "1"};
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: ${(props) => {
      if (!props.$active) return "transparent";
      return props.$dashboard === "products" ? "#10b981" : "#10b981";
    }};
    border-radius: 0 2px 2px 0;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  p {
    font-size: 0.85em;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: ${(props) =>
      props.$menuMinimized ? "0" : props.$active ? "1" : "0.8"};
    width: ${(props) => (props.$menuMinimized ? "0" : "auto")};
    overflow: hidden;
    white-space: nowrap;
    font-weight: ${(props) => (props.$active ? "600" : "400")};
    margin: 0;
    padding: 0;
  }

  svg {
    opacity: ${(props) => (props.$active ? ".8" : ".5")};
    margin: ${(props) => (props.$menuMinimized ? "0" : "0 10px 0 12px")};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: ${(props) => (props.$menuMinimized ? "1.2em" : "1em")};
    color: #e5e7eb;
    flex-shrink: 0;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.04);

    svg {
      opacity: 0.9;
    }

    p {
      opacity: 1;
    }
  }
`;

export const UserMenu = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  background-color: rgba(13, 15, 20, 0.5);
  backdrop-filter: blur(16px);
  bottom: 0;
  position: sticky;
  z-index: 10;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-direction: column;
  cursor: pointer;
  opacity: 0.8;
  border-top: 1px solid rgba(255, 255, 255, 0.04);

  &:hover {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.03);
  }

  .user {
    width: 100%;
    min-height: 4em;
    height: max-content;
    display: flex;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
    justify-content: ${(props) =>
      props.$menuMinimized ? "center" : "flex-start"};
    padding: 8px 0;
    transition: all 0.2s ease;

    &:hover {
      .circle {
        transform: scale(1.05);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
      }
    }

    .thumb {
      width: 4em;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .circle {
        width: 2.2em;
        height: 2.2em;
        border-radius: 100%;
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        justify-content: center;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        p {
          font-size: 0.75em;
          font-weight: 700;
          color: #ffffff;
          letter-spacing: 0.5px;
        }
      }
    }

    .text {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
      padding-right: 12px;
      opacity: ${(props) => (props.$menuMinimized ? "0" : "1")};
      overflow: hidden;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      .user-name {
        font-size: 0.85em;
        line-height: 1.3;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 600;
        color: #e5e7eb;
        margin-bottom: 2px;
      }

      .user-email {
        font-size: 0.7em;
        line-height: 1.2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        opacity: 0.6;
        color: #a0a0a0;
      }
    }
  }

  .logout-btn {
    width: 100%;
    height: 2.8em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 1em;
    background: rgba(239, 68, 68, 0.1);
    border: none;
    border-top: 1px solid rgba(239, 68, 68, 0.2);
    color: #ef4444;
    font-size: 0.85em;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    animation: slideDown 0.2s ease-out;

    svg {
      font-size: 1.2em;
      margin-right: 8px;
    }

    span {
      font-family: inherit;
    }

    &:hover {
      background: rgba(239, 68, 68, 0.2);
      color: #ff5555;
    }

    &:active {
      transform: scale(0.98);
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const MinimizeButton = styled.div`
  position: ${(props) => (props.$isBelowIcon ? "relative" : "absolute")};
  right: ${(props) => (props.$isBelowIcon ? "auto" : "8px")};
  top: ${(props) => (props.$isBelowIcon ? "auto" : "50%")};
  transform: ${(props) => (props.$isBelowIcon ? "none" : "translateY(-50%)")};
  margin: ${(props) => (props.$isBelowIcon ? "0.5em auto" : "0")};
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.6;
  z-index: 10;

  svg {
    font-size: 14px;
    color: #e5e7eb;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    opacity: 1;
    transform: ${(props) =>
      props.$isBelowIcon ? "scale(1.05)" : "translateY(-50%) scale(1.05)"};
  }

  &:active {
    transform: ${(props) =>
      props.$isBelowIcon ? "scale(0.95)" : "translateY(-50%) scale(0.95)"};
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 9998;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const UserModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme?.card || "#1f2937"};
  border: 1px solid ${({ theme }) => theme?.border || "rgba(255, 255, 255, 0.1)"};
  border-radius: 12px;
  width: 90%;
  max-width: 450px;
  z-index: 9999;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: slideIn 0.3s ease;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translate(-50%, -45%);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5em;
    border-bottom: 1px solid ${({ theme }) => theme?.border || "rgba(255, 255, 255, 0.1)"};

    h3 {
      margin: 0;
      font-size: 1.2em;
      font-weight: 600;
      color: ${({ theme }) => theme?.text || "#e5e7eb"};
    }

    .close-btn {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s ease;
      color: ${({ theme }) => theme?.text || "#e5e7eb"};
      opacity: 0.6;

      svg {
        font-size: 18px;
      }

      &:hover {
        opacity: 1;
        background: rgba(255, 255, 255, 0.06);
        border-radius: 12px;
      }
    }
  }

  .modal-body {
    padding: 1.5em;
    display: flex;
    flex-direction: column;
    gap: 1.2em;

    .user-profile {
      display: flex;
      align-items: center;
      gap: 1em;
      padding-bottom: 1.2em;
      border-bottom: 1px solid ${({ theme }) => theme?.border || "rgba(255, 255, 255, 0.1)"};
      margin-bottom: 0.5em;

      .profile-thumb {
        display: flex;
        align-items: center;
        justify-content: center;

        .profile-circle {
          width: 3.5em;
          height: 3.5em;
          border-radius: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #1f2937;
          border: 2px solid #10b981;

          p {
            font-size: 1.2em;
            font-weight: 700;
            color: #10b981;
            margin: 0;
          }
        }
      }

      .profile-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.3em;

        h4 {
          margin: 0;
          font-size: 1.1em;
          font-weight: 600;
          color: ${({ theme }) => theme?.text || "#e5e7eb"};
        }

        p {
          margin: 0;
          font-size: 0.85em;
          color: ${({ theme }) => theme?.text || "#e5e7eb"};
          opacity: 0.6;
        }
      }
    }

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 0.5em;

      label {
        font-size: 0.85em;
        font-weight: 600;
        color: ${({ theme }) => theme?.text || "#e5e7eb"};
        opacity: 0.8;
      }

      input {
        padding: 0.8em 1em;
        background: ${({ theme }) => theme?.card || "#1f2937"};
        border: 1px solid ${({ theme }) => theme?.border || "rgba(255, 255, 255, 0.1)"};
        border-radius: 12px;
        color: ${({ theme }) => theme?.text || "#e5e7eb"};
        font-size: 0.95em;
        transition: all 0.2s ease;

        &:focus {
          outline: none;
          border-color: #10b981;
          box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
        }

        &::placeholder {
          color: ${({ theme }) => theme?.text || "#e5e7eb"};
          opacity: 0.4;
        }
      }
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5em;
    border-top: 1px solid ${({ theme }) => theme?.border || "rgba(255, 255, 255, 0.1)"};
    gap: 1em;

    button {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5em;
      padding: 0.8em 1.5em;
      border: none;
      border-radius: 12px;
      font-size: 0.9em;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;

      svg {
        font-size: 16px;
      }
    }

    .btn-logout {
      background: transparent;
      border: 1px solid rgba(239, 68, 68, 0.3);
      color: #ef4444;

      &:hover {
        background: rgba(239, 68, 68, 0.1);
        border-color: #ef4444;
      }
    }

    .btn-save {
      background: #10b981;
      color: #fff;

      &:hover {
        background: #059669;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
      }
    }
  }
`;
